import { RunningProjects } from '~/@pages_investing/projects/running-projects/RunningProjects'
import { ArchivedProjects } from '~/@pages_investing/projects/archived-projects/ArchivedProjects'

function ProjectsPage() {
  return (
    <>
      <RunningProjects />
      <ArchivedProjects />
    </>
  )
}

export default ProjectsPage
